import { getFormattedDate, initializeRouteMap } from '../functions.js';

jQuery(function($) {
    if ($('.single-activiteit').length == 0) {
        return;
    }

    let urlParams = new URLSearchParams(window.location.search);
    let activityId = urlParams.get('id'); 

    $.get("/wp-json/wemake/v1/get-token", function (response) {
        if (response.token) {
            fetchActivity(response.token);
        }
        else {
            console.log('no valid token');
        }
    });

    function fetchActivity(token) {
        $.ajax({
            url: 'https://cockpit.qr-fit.nl/ext-website/v1/activities/' + activityId,
            method: "GET",
            headers: { "Authorization": "Bearer " + token },
            success: function (activity) {
                let detailsContainer = $(".activiteit__content"); 
                console.log(activity);
                $('.aanmelden-formulier form').find('input[name="activiteit-id"').val(activity.id);
                $('.aanmelden-formulier form').find('input[name="activiteit-naam"').val(activity.title);

                var isoDate = activity.start_date; // e.g. "2025-07-16T17:00:00.000000Z"
                var parts = isoDate.split('T')[0].split('-');
                var formattedDate2 = parts[2] + '-' + parts[1] + '-' + parts[0];

                $('.aanmelden-formulier form').find('input[name="activiteit-datum"').val(formattedDate2);

                $('.activiteit__title').text(activity.title);
                // Route length
                let lengthHTML = activity.route && activity.route.length_in_km ? `
                    <div class="d-f gap-8 f-a-c fw-n">
                        <img width="22" height="22" src="/wp-content/uploads/2024/10/Afstand-icoontje-1.svg" alt="">
                        <div><strong>Lengte </strong> <span class="t-c-s">${activity.route.length_in_km} km</span></div>
                    </div>
                ` : '';

                // Exercise points count
                let exercisesHTML = activity.route && activity.route.exercise_points ? `
                    <div class="d-f gap-8 f-a-c fw-n">
                        <img width="22" height="22" src="/wp-content/uploads/2024/10/Icon-fill-1.svg" alt="">
                        <div><strong>Oefeningen </strong> <span class="t-c-s">${activity.route.exercise_points.length}</span></div>
                    </div>
                ` : '';

                // Initialize Google Maps with either a route or just a single start coordinate
                document.querySelectorAll('.route__map').forEach((mapElement) => {
                    if (activity.route && activity.route.exercise_points && activity.route.waypoints) {
                        initializeRouteMap(mapElement, activity.route.exercise_points, activity.route.waypoints);
                    } else if (activity.start_coordinate) {
                        initializeRouteMap(mapElement, [activity.start_coordinate]);
                        // Route length
                        lengthHTML = `<div class="d-f gap-8 f-a-c fw-n">
                            <img width="22" height="22" src="/wp-content/uploads/2024/10/Afstand-icoontje-1.svg" alt="">
                            <div><strong>Lengte </strong> <span class="t-c-s">Vrij in te vullen</span></div>
                        </div>`;
                        exercisesHTML = `<div class="d-f gap-8 f-a-c fw-n">
                                <img width="22" height="22" src="/wp-content/uploads/2024/10/Icon-fill-1.svg" alt="">
                                <div><strong>Oefeningen </strong> <span class="t-c-s">Vrij in te vullen</span></div>
                            </div>`;
                    }
                });
                
                // Format date if available
                let formattedDate = activity.start_date ? getFormattedDate(activity.start_date, true) : '';

                // Extract and format start time (HH:MM)
                let startTime = activity.start_date ? new Date(activity.start_date).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }) : '';

                // Location
                let locationHTML = activity.location_name ? `
                    <div class="d-f gap-8 f-a-c fw-n">
                        <img width="22" height="22" src="/wp-content/uploads/2024/10/Icon-fill.svg" alt="">
                        <div>${activity.location_name}</div>
                    </div>
                ` : '';

                // Estimated duration (if available)
                let durationHTML = activity.route && activity.route.estimated_duration_in_minutes ? `
                    <div class="d-f gap-8 f-a-c fw-n">
                        <img width="22" height="22" src="/wp-content/uploads/2024/10/Icon-fill-5.svg" alt="">
                        <div><strong>Duur </strong> <span class="t-c-s">${activity.route.estimated_duration_in_minutes} min</span></div>
                    </div>
                ` : '';

                // Start time (HH:MM)
                let startTimeHTML = startTime ? `
                <div class="d-f gap-8 f-a-c fw-n">
                    <img width="22" height="22" src="/wp-content/uploads/2024/10/Icon-fill-6.svg" alt="">
                    <div><strong>Starttijd </strong> <span class="t-c-s">${startTime}</span></div>
                </div>
            ` : '';

                if (activity.description) {
                    $('.activiteit__beschrijving').text(activity.description);
                } 

                if (activity.team && activity.team.name){
                    $('.activiteit__team-name').text(activity.team.name);
                }

                if (activity.team && activity.team.avatar){
                    $('.activiteit__team-foto').attr('src', activity.team.avatar.small);
                    $('.activiteit__team-foto').removeClass('hidden');
                }

                if (activity.route && activity.route.type){
                    let text = activity.route.type == 'virtual' ? 'Virtuele route' : 'Fysieke route';
                    $('.activiteit__route').text(text);
                }

                // Generate the final HTML only if there is valid data
                if (formattedDate || locationHTML || lengthHTML || durationHTML || exercisesHTML || startTimeHTML) {
                    let activiteitHTML = `
                        <div class="d-f-2 d-f-1-s gap-16">
                            ${formattedDate ? `<div>${formattedDate}</div>` : ''}
                            ${locationHTML}
                            ${lengthHTML}
                            ${durationHTML}
                            ${exercisesHTML}
                            ${startTimeHTML}
                        </div>
                    `;

                    detailsContainer.html(activiteitHTML);
                }  
            },
            error: function (xhr) {
                console.error("Error fetching cached activity details: " + xhr.responseText);
            }
        });
    }

});





